import { render, staticRenderFns } from "./RollCall.vue?vue&type=template&id=b0a44be6&"
import script from "./RollCall.vue?vue&type=script&lang=js&"
export * from "./RollCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports